import React from 'react'
import { WidgetGuard } from 'features/types'
import {
  TopicInaccessibleGuard,
  TopicLanguageNotSupportedGuard,
  TopicIndexNotReadyGuard,
  WidgetLoadingGuard
} from 'components/widget/share/guards'
import DayAndHourEmptyResultGuard from './DayAndHourEmptyResultGuard'

const PostSearchDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <WidgetLoadingGuard widgetId={widgetId}>
    <TopicInaccessibleGuard widgetId={widgetId}>
      <TopicLanguageNotSupportedGuard widgetId={widgetId}>
        <TopicIndexNotReadyGuard widgetId={widgetId}>
          <DayAndHourEmptyResultGuard widgetId={widgetId}>{children}</DayAndHourEmptyResultGuard>
        </TopicIndexNotReadyGuard>
      </TopicLanguageNotSupportedGuard>
    </TopicInaccessibleGuard>
  </WidgetLoadingGuard>
)

export default PostSearchDataGuards
